import { useEffect, useState } from 'react';
import './CmsReviewsCarousel.css';

export const CmsReviewsCarousel = (): JSX.Element => {
	const [activeIndex, setActiveIndex] = useState(-1);
	const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
	const listItemCount = 3;
	const updateInterval = 5000;

	const updateActiveIndex = () => {
		setActiveIndex((prevIndex) => (prevIndex + 1) % listItemCount);
	};

	useEffect(() => {
		updateActiveIndex();
		const intervalId = setInterval(updateActiveIndex, updateInterval);
		setIntervalId(intervalId);

		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
		};
	}, []);

	const handleLogoClick = (index: number) => {
		if (intervalId) {
			clearInterval(intervalId);
		}

		const id = setInterval(updateActiveIndex, updateInterval);
		setIntervalId(id);
		setActiveIndex(index);
	};

	return (
		<div>
			<div id="reviews-carousel-wrapper">
				<Image imageSrc="/images/sam-convendum.jpeg" active={activeIndex === 0} />
				<Image imageSrc="/images/patrick-ceo.jpg" active={activeIndex === 1} />
				<Image imageSrc="/images/carina.png" active={activeIndex === 2} />
				<Quote
					quote="Vi är supernöjda med vårt samarbete sedan start med flera tjänster under Worky, som en riktigt smidig lösning för våra f.n. 18 kontorshotell"
					quoteeText="Sam Ersson Ciavaldini"
					quotee="Regional Manager, Convendum"
					active={activeIndex === 0}
				/>
				<Quote
					quote="Vi är väldigt nöjda med Worky som sköter städningen av våra lokaler med superduktig och trevlig personal. Tack för att ni gör vårt arbetsutrymme så rent och trivsamt!"
					quoteeText="Patrick Verkland"
					quotee="COO, The Humble Co."
					active={activeIndex === 1}
				/>
				<Quote
					quote="Vi är väldigt nöjda med all hjälp vi har fått i tjänsterna från Worky. Exempelvis gick flytt & montering av möbler i våra lokaler fantastiskt smidigt!"
					quoteeText="Carina Palmqvist"
					quotee="Reception & Kontor, Företagarna"
					active={activeIndex === 2}
				/>
			</div>
			<Logos activeIndex={activeIndex} onItemClick={handleLogoClick} />
		</div>
	);
};

type QuoteProps = { quote: string; quoteeText: string; quotee: string; active: boolean };
const Quote = ({ quote, quoteeText, quotee, active }: QuoteProps): JSX.Element => {
	return (
		<div className={`quote ${active ? 'active' : ''}`}>
			<img src="/images/quotes.svg" className="quotes" />
			<blockquote>{quote}</blockquote>
			<p className="quotee-text">{quoteeText}</p>
			<p className="quotee">{quotee}</p>
		</div>
	);
};

type ImageProps = { imageSrc: string; active: boolean };
const Image = ({ imageSrc, active }: ImageProps): JSX.Element => {
	return (
		<div className={`image ${active ? 'active' : ''}`}>
			<img src={imageSrc} />
		</div>
	);
};

type LogosProps = { activeIndex: number; onItemClick: (clickedIndex: number) => void };
const Logos = ({ activeIndex, onItemClick }: LogosProps): JSX.Element => {
	return (
		<div id="logos">
			<Logo
				imageSrc="/images/convendum-logo.png"
				active={activeIndex === 0}
				className="line-one"
				index={0}
				onItemClick={onItemClick}
			/>
			<Logo
				imageSrc="/images/humble-co-logo.png"
				active={activeIndex === 1}
				className="line-two"
				index={1}
				onItemClick={onItemClick}
			/>
			<Logo
				imageSrc="/images/fore-logo-black.png"
				active={activeIndex === 2}
				className="line-three"
				index={2}
				onItemClick={onItemClick}
			/>
		</div>
	);
};

type LogoProps = {
	imageSrc: string;
	className: string;
	active: boolean;
	onItemClick: (clickedIndex: number) => void;
	index: number;
};
const Logo = ({ imageSrc, className, active, index, onItemClick }: LogoProps): JSX.Element => {
	return (
		<>
			<div className={`logo ${active ? 'active' : ''}`} onClick={() => onItemClick(index)}>
				<img src={imageSrc} />
			</div>
			<div
				className={`progress-line-wrapper ${active ? 'active' : ''} ${className}`}
				onClick={() => onItemClick(index)}
			>
				<div className="progress-line-grey" />
				<div className="progress-line-black" />
			</div>
		</>
	);
};
